// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+6PXV","board":"styles_board__Ge95t","activeBoard":"styles_activeBoard__UXhO+","hoverColor":"styles_hoverColor__fHUdn"};